module.exports = __webpack_public_path__ + "static/media/closing-modal-site.873a8b42.jpg";